var React = require('react');

function AngleRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.318 0.269c0.404-0.377 1.037-0.355 1.413 0.049l12.090 12.953c1.434 1.537 1.434 3.922 0 5.459l-12.090 12.953c-0.377 0.404-1.010 0.425-1.413 0.049s-0.426-1.010-0.049-1.413l12.089-12.953c0.717-0.768 0.717-1.961 0-2.729l-12.089-12.953c-0.377-0.404-0.355-1.037 0.049-1.413z"}));
}

AngleRight.defaultProps = {"version":"1.1","viewBox":"0 0 32 32"};

module.exports = AngleRight;

AngleRight.default = AngleRight;
